import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Tenant } from 'src/app/core/models/tenant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'any'
})
export class UserTenantService {
  private http = inject(HttpClient);

  private URL = `${environment.RH_BASE_URL}/mgmt/tenants`;

  loadUserTenant(tenantId: string | number = 'acme'): Observable<Tenant.Tenant> {
    return this.http.get<Tenant.Tenant>(`${this.URL}/${tenantId}`);
  }
}
